import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IModule, IPromise, IQService} from "angular";
import {DialogInterface} from "felles/tjenester/Dialog";

const css = require('./dialog.scss');

export class Dialog implements DialogInterface {

    static regNavn = "Dialog";

    static registrerTjeneste(angular: IModule) {
        angular
            .service(Dialog.regNavn, [
                regNavn.ng.material.$mdDialog,
                Dialog
            ]);
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    alert(tittel: string, innhold: string): angular.IPromise<any> {
        return this.$mdDialog.show(
            this.$mdDialog.alert()
                .clickOutsideToClose(true)
                .title(tittel)
                .textContent(innhold)
                .ok('Ok')
        );
    }

    alertMedHtmlInnhold(tittel: string, htmlInnhold: string): angular.IPromise<any> {
        return this.$mdDialog.show(
            this.$mdDialog.alert()
                .clickOutsideToClose(true)
                .title(tittel)
                .htmlContent(`<div class="wt-dialog-alert-kropp">${htmlInnhold}</div>`)
                .ok('Ok')
        );
    }

    confirm(tittel: string, htmlInnhold: string, okLabel: string, cancelLabel: string): IPromise<any> {
        return this.$mdDialog.show(
            this.$mdDialog.confirm()
                .clickOutsideToClose(true)
                .title(tittel)
                .htmlContent(`<div class="wt-dialog-confirm-kropp">${htmlInnhold}</div>`)
                .multiple(true)
                .ok(okLabel)
                .cancel(cancelLabel)
        );
    }
}

export interface MdDialogController {
    /**
     * Called on each controller after all the controllers on an element have been constructed and had their bindings
     * initialized (and before the pre & post linking functions for the directives on this element). This is a good
     * place to put initialization code for your controller.
     */
    $onInit?(): void;

    /**
     * Called on a controller when its containing scope is destroyed. Use this hook for releasing external resources,
     * watches and event handlers.
     */
    $onDestroy?(): void;
}
